var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "详情",
            visible: _vm.dialog.visible,
            "append-to-body": "",
            "modal-append-to-body": false,
            "close-on-click-modal": true,
            width: "60%",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.dialog, "visible", $event)
            },
            closed: _vm.closed,
          },
        },
        [
          _c(
            "div",
            [
              _c("div", { staticClass: "plugin-manage-top" }, [
                _c("div", { staticClass: "left" }, [
                  _c("span", { staticClass: "ellipsis" }, [
                    _c("p", [_vm._v("插件名称：")]),
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.pluginGroupData.name) +
                        "\n            "
                    ),
                  ]),
                  _c("span", { staticClass: "ellipsis" }, [
                    _c("p", [_vm._v("插件渠道：")]),
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.pluginGroupData.channel) +
                        "\n            "
                    ),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "right" },
                  [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "auth",
                            rawName: "v-auth",
                            value: "pluginManagePluginManageUpload",
                            expression: "'pluginManagePluginManageUpload'",
                          },
                        ],
                        attrs: { type: "primary", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.handleAdd(
                              _vm.pluginGroupData.pluginGroupId
                            )
                          },
                        },
                      },
                      [_vm._v("上传插件")]
                    ),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "plugin-manage-search" }, [
                _c(
                  "div",
                  [
                    _c("el-input", {
                      staticStyle: { width: "150px" },
                      attrs: {
                        clearable: "",
                        size: "small",
                        placeholder: "版本号",
                      },
                      model: {
                        value: _vm.searchParams.search,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchParams, "search", $$v)
                        },
                        expression: "searchParams.search",
                      },
                    }),
                    _c(
                      "el-select",
                      {
                        staticStyle: { "margin-left": "15px", width: "150px" },
                        attrs: {
                          clearable: "",
                          size: "small",
                          placeholder: "状态",
                        },
                        model: {
                          value: _vm.searchParams.status,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchParams, "status", $$v)
                          },
                          expression: "searchParams.status",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "上线", value: "1" },
                        }),
                        _c("el-option", {
                          attrs: { label: "下线", value: "0" },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "auth",
                            rawName: "v-auth",
                            value: "pluginManagePluginManageSearch",
                            expression: "'pluginManagePluginManageSearch'",
                          },
                        ],
                        attrs: { type: "primary", size: "small" },
                        on: { click: _vm.search },
                      },
                      [_vm._v("搜索")]
                    ),
                  ],
                  1
                ),
              ]),
              _c(
                "el-table",
                { attrs: { data: _vm.list, border: "", stripe: "" } },
                [
                  _c("el-table-column", {
                    attrs: { label: "版本", prop: "ver" },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "发布时间", prop: "createTime" },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "最小支持版本", prop: "minHostVer" },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "操作", width: "200" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.status === 0
                              ? _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "auth",
                                        rawName: "v-auth",
                                        value: "pluginManagePluginManageOnline",
                                        expression:
                                          "'pluginManagePluginManageOnline'",
                                      },
                                    ],
                                    attrs: { type: "text", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleChangeStatus(
                                          scope.row,
                                          "1"
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("上线")]
                                )
                              : _vm._e(),
                            scope.row.status === 1
                              ? _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "auth",
                                        rawName: "v-auth",
                                        value:
                                          "pluginManagePluginManageOffline",
                                        expression:
                                          "'pluginManagePluginManageOffline'",
                                      },
                                    ],
                                    attrs: { type: "text", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleChangeStatus(
                                          scope.row,
                                          "0"
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("下线")]
                                )
                              : _vm._e(),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "auth",
                                    rawName: "v-auth",
                                    value: "pluginManagePluginManageEdit",
                                    expression:
                                      "'pluginManagePluginManageEdit'",
                                  },
                                ],
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleEdit(
                                      scope.row,
                                      _vm.pluginGroupData.pluginGroupId
                                    )
                                  },
                                },
                              },
                              [_vm._v("编辑")]
                            ),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "auth",
                                    rawName: "v-auth",
                                    value: "pluginManagePluginManageDel",
                                    expression: "'pluginManagePluginManageDel'",
                                  },
                                ],
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDel(scope.row.id)
                                  },
                                },
                              },
                              [_vm._v("删除")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c("ElementPagination", {
                staticStyle: { "margin-bottom": "20px" },
                attrs: {
                  "current-page": _vm.searchParams.current,
                  "page-size": _vm.searchParams.size,
                  total: _vm.searchParams.total,
                  "page-sizes": [10, 20, 30, 40, 50],
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            { staticStyle: {}, attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.hide } },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.confirm()
                    },
                  },
                },
                [_vm._v("保 存")]
              ),
            ],
            1
          ),
          _c("UpLoadDialog", {
            ref: "uploadPlugin",
            on: {
              reload: function ($event) {
                return _vm.getList()
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }